/**
 * Version Formatting Utility
 * 대외 제품 버전은 핫픽스/패치가 있더라도 항상 2자리(Major.Minor, 예: '1.0')로 고정 표기합니다.
 */
export function formatProductVersion(ver?: string): string {
  if (!ver) return '1.0';
  const clean = ver.trim().replace(/^v/i, '');
  const parts = clean.split('.');
  const major = parts[0] || '1';
  const minor = parts[1] || '0';
  return `${major}.${minor}`;
}
